export class Settings {
    public static language = 'en';
}